<template>
  <autocomplete
    ref="autocomplete"
    :placeholder="label"
    :source="localData"
    :initialValue="initialValue"
    :initialDisplay="initialDisplay"
    input-class="form-control"
    results-value="code"
    :results-display="formattedDisplay"
    @input="getResult"
    @clear="getResult('')">
  </autocomplete>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'
import { formatValue, formatList } from '@/assets/scripts/formatData'

export default {
  name: 'ZanaAutocomplete',
  props: ['data', 'label', 'initialValue', 'initialDisplay', 'index', 'group'],
  components: {
    Autocomplete
  },
  data: () => ({
    localData: []
  }),
  mounted () {
    if (this.group === undefined) {
      this.localData = this.data
    } else if (this.group.length > 0) {
      this.localData = formatList(this.data[this.group])
    }
  },
  watch: {
    group: function () {
      this.$refs.autocomplete.clear()
      this.localData = formatList(this.data[this.group])
    }
  },
  methods: {
    getResult (result) {
      if (this.index === undefined) {
        this.$emit('result', result)
      } else {
        this.$emit('result', result, this.index)
      }
    },

    formattedDisplay (result) {
      return formatValue(result)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
